var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "500"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Manage SSH key ")]
          ),
          _c("v-card-text", [
            _c("p", [
              _vm._v(
                " The key with the name “" +
                  _vm._s(_vm.sshKey.name) +
                  "” is currently “"
              ),
              _c("strong", [_vm._v(_vm._s(_vm.sshKey.authstatus))]),
              _vm._v("” for use when connecting to this account. ")
            ])
          ]),
          _c(
            "v-card-actions",
            {
              staticClass: "justify-content-end"
            },
            [
              _c(
                "gg-btn",
                {
                  staticClass: "mb-0",
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "gg-btn",
                {
                  staticClass: "mb-0",
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.manage
                  }
                },
                [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }